module.exports = __webpack_public_path__ + "static/media/gr.a2a75ea9.svg";